'use strict';

class ProductPicker {
  constructor($scope, $filter, productService, commonService, userService, originatorService) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.productService = productService;
    this.commonService = commonService;
    this.userService = userService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.alert = {
      type: 'error',
      message: `Ugyldig tallformat. Tall må skrives uten tusentallskille og med maksimalt to desimaler, for eksempel: 199,50`
    };

    this.taxRates = [];
    this.taxesLoaded = false;
    this.featuresLoaded = false;
    //code, qty
    this.productStock = {};
    this.invalidStockProducts = [];

    this.userService.get()
      .then((resp) => {
        this.featuresLoaded = true;
        if (this.taxesLoaded) {
          this.checkArtTaxAdded();
          this.items.forEach((item) => this.calculateSum(item), this);
          this.calculateTotal(this.items);
          this.$scope.$emit('productList', this.items);
        }
      });

    this.originatorService.settings()
      .then((resp) => {
        this.defaults = resp.data.defaults;

        this.artTaxEnabled = resp.data.defaults.artTaxEnabled;
        if (this.artTaxEnabled) {
          this.artTaxText = resp.data.defaults.artTax.artTaxText;
          this.artTaxPercent = resp.data.defaults.artTax.artTaxPercent;
        }
      });

    // get taxRates
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
        this.taxesLoaded = true;
        if (this.featuresLoaded) {
          this.checkArtTaxAdded();
          this.items.forEach((item) => this.calculateSum(item), this);
          this.calculateTotal(this.items);
          this.$scope.$emit('productList', this.items);
        }
      });

    this.items = [];
    this.products = [];
    this.discount = parseFloat(this.discount) || 0;
    this.mva = this.mva || true;

    this.i18n = this.i18n || {
      QUANTITY: 'Antall',
      CODE: 'Produktnr',
      DESCRIPTION: 'Beskrivelse',
      UNITPRICE: 'Enhetpris',
      DISCOUNT: 'Rab.%',
      TAXRATE: 'MVA',
      TOTAL: 'Sum'
    };

    this.maxItems = this.maxItems || 18;
    this.checkStock = this.checkStock || false;

    this.panel = false;

    this.productService.list()
      .then((resp) => {
        this.products = resp.data.items;
      });

    if (!this.items.length) {
      this.items.push({
        number: 1,
        quantity: 1,
        productCode: null,
        description: null,
        unitPrice: null,
        discount: null,
        taxRate: 25,
        total: null,
        artTax: false
      }, {
        number: 2,
        quantity: null,
        productCode: null,
        description: null,
        unitPrice: null,
        discount: null,
        taxRate: 25,
        total: null,
        artTax: false
      }, {
        number: 3,
        quantity: null,
        productCode: null,
        description: null,
        unitPrice: null,
        discount: null,
        taxRate: 25,
        total: null,
        artTax: false
      });
    }
  }

  prepareMessage() {
    if (this.invalidStockProducts.length === 0) {
      return '';
    } else {
      let message = 'Gjenstående lagerbeholdning er: <br>';
      this.invalidStockProducts.forEach((prodCode) => {
        let max = this.productStock[prodCode];
        message += 'Produkt ' + prodCode + ': ' + max + '<br>';
      });
      return message;
    }
  }

  checkArtTaxAdded() {
    this.items.forEach((item) => {
      if (item.artTax) {
        this.artTaxAdded = true;
      }
    });
  }

  $onChanges() {
    if (!this.taxesLoaded || !this.featuresLoaded) {
      return;
    }
    const _this = this;

    // reset taxRates if necessary
    if (this.items) {
      this.checkArtTaxAdded();
      if (!this.mva) {
        this.items.map((item) => {
          item.taxRate = 0;
          return item;
        });
      }
      this.items.forEach((item) => this.calculateSum(item), this);
    }

    //when draft items finally loaded
    this.validateStockForAll();

    // sorting
    $('#invoiceLines tbody').sortable({
      handle: '.fa-sort',
      placeholder: 'ui-state-highlight',
      axis: 'y',
      cursor: 'move',
      revert: true,
      stop: (event, ui) => {
        _this.$scope.$apply(() => {
          let index = parseInt(ui.item.attr('data-index'), 10);
          let newIndex = ui.item.index();

          // move
          _this.items.splice(newIndex, 0, _this.items.splice(index, 1)[0]);
        });

        // reindex
        _this.items.map((item, i) => {
          item.number = i + 1;
          return item;
        });
      }
    });

    this.$scope.$emit('productSummary', this.calculateTotal(this.items));
    this.$scope.$emit('productList', this.items);
  }

  calc(item) {
    let quantity = this.$filter('numberify')(item.quantity) || 0;
    let unitPrice = this.$filter('numberify')(item.unitPrice) || 0;
    let discount = parseFloat(item.discount) || 0;
    let taxRate = parseFloat(item.taxRate) || 0;

    let ONE_HUNDRED = 100.00;
    let priceBeforeDiscount = quantity * unitPrice;
    let unitDiscount = priceBeforeDiscount * discount / ONE_HUNDRED;
    let totalBeforeTax = (priceBeforeDiscount - unitDiscount);
    totalBeforeTax = this.round(totalBeforeTax);

    let taxAmount = totalBeforeTax * taxRate / ONE_HUNDRED;
    taxAmount = this.round(taxAmount);

    let totalIncludingTax = totalBeforeTax + taxAmount;

    return {
      net: totalBeforeTax,
      tax: taxAmount,
      total: totalIncludingTax
    };
  }

  round(value) {
    let decimals = 2;
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
  }

  calcArtTax(items) {
    let total = 0;

    let ONE_HUNDRED = 100.00;

    if (items && items.length) {
      //clone the array not to change original objects
      let clone = angular.copy(items);

      clone.forEach((item) => {
        if (!item.artTax) {
          let quantity = this.$filter('numberify')(item.quantity) || 0;
          let unitPrice = this.$filter('numberify')(item.unitPrice) || 0;
          let discount = parseFloat(item.discount) || 0;

          if (quantity > 0 && unitPrice !== 0) {
            // perform the calculations
            let unitTotal = quantity * unitPrice;

            let priceBeforeDiscount = quantity * unitPrice;
            let unitDiscount = unitTotal * discount / ONE_HUNDRED;
            let totalBeforeTax = priceBeforeDiscount - unitDiscount;
            let totalBeforeTaxRounded = this.round(totalBeforeTax);

            total += totalBeforeTaxRounded;
          }
        }
      }, this);
    }

    let netTaxAmount = 0;

    netTaxAmount += parseFloat(total.toFixed(4));

    return this.round(netTaxAmount * this.artTaxPercent / 100);
  }

  recalculateArtTaxLine() {
    if (this.artTaxAdded && this.artTaxEnabled) {
      this.items.forEach((item) => {
        if (item.artTax) {
          item.unitPrice = this.calcArtTax(this.items);
          item.total = this.calc(item).total;
          item.total = this.round(item.total);
          item.net = this.calc(item).net;
        }
      });
    }
  }

  strip(number) {
    return (parseFloat(number).toPrecision(12));
  }

  calculateTotal(items) {
    if (!this.taxesLoaded || !this.featuresLoaded) {
      return;
    }

    if (this.taxRates === undefined || this.taxRates.length === 0) {
      return;
    }

    let l = this.taxRates.length;
    let net = Array.apply(null, new Array(l)).map(Number.prototype.valueOf, 0);
    let tax = Array.apply(null, new Array(l - 1)).map(Number.prototype.valueOf, 0);

    let total = 0;
    let ONE_HUNDRED = 100.00;

    if (items && items.length) {
      //first recalculate artTax line
      this.recalculateArtTaxLine();

      //clone the array not to change original objects
      let clone = angular.copy(items);

      clone.forEach((item) => {
        let quantity = this.$filter('numberify')(item.quantity) || 0;
        let unitPrice = this.$filter('numberify')(item.unitPrice) || 0;
        let discount = parseFloat(item.discount) || 0;
        let taxRate = parseFloat(item.taxRate) || 0;

        if (quantity > 0 && unitPrice !== 0) {
          // perform the calculations
          let unitTotal = quantity * unitPrice;
          let priceBeforeDiscount = this.strip(unitTotal);
          let unitDiscount = priceBeforeDiscount * discount / ONE_HUNDRED;
          let totalBeforeTax = priceBeforeDiscount - unitDiscount;
          let totalBeforeTaxRounded = this.round(totalBeforeTax);

          // Add the taxation for this item to our collection of taxes
          let foundTaxIndex = this.taxRates.indexOf(taxRate);

          if (foundTaxIndex > -1) {
            // group taxRates
            if (item.taxRate === 0) {
              net[0] += totalBeforeTaxRounded;
            } else {
              net[foundTaxIndex] += totalBeforeTaxRounded;
              let roundedInvoiceItemTotalEksMva = this.round(net[foundTaxIndex]);
              let taxValue = item.taxRate * roundedInvoiceItemTotalEksMva / ONE_HUNDRED;
              tax[foundTaxIndex - 1] = taxValue;
            }
          }
        }
        return item;
      }, this);
    }

    let invoiceTaxAmount = 0;
    let netTaxAmount = 0;

    net.forEach((n) => {
      netTaxAmount += parseFloat(n.toFixed(4));
    });

    tax.forEach((t) => {
      invoiceTaxAmount += this.round(parseFloat(t.toFixed(4)));
      // invoiceTaxAmount += this.$filter('round')(parseFloat(t.toFixed(4)));
    });

    let roundedTax = this.round(invoiceTaxAmount);
    let roundedNet = this.round(netTaxAmount);
    // let roundedTax = this.$filter('round')(invoiceTaxAmount);
    // let roundedNet = this.$filter('round')(netTaxAmount);

    total = roundedNet + roundedTax;

    return {
      net: net,
      tax: tax,
      total: this.round(total),
      taxRates: this.taxRates
    };
  }

  validateStockForAll() {
    if (this.checkStock) {
      this.invalidStockProducts = [];
      this.items.forEach((item) => {
        if (item.productCode && item.productCode.length) {
          if (item.productCode in this.productStock) {
            let maxQty = this.productStock[item.productCode];
            let quantity = this.$filter('numberify')(item.quantity) || 0;
            if (quantity > maxQty) {
              if (!this.invalidStockProducts.includes(item.productCode)) {
                this.invalidStockProducts.push(item.productCode);
              }
            }
          } else {
            this.productService.search(item.productCode)
              .then((resp) => {
                if (resp.data.items.length) {
                  let result = resp.data.items[0];
                  if (result.stockManaged) {
                    if (!(result.code in this.productStock)) {
                      this.productStock[result.code] = result.quantity | 0;
                    }

                    let maxQty = result.quantity;
                    let quantity = this.$filter('numberify')(item.quantity) || 0;
                    if (quantity > maxQty) {
                      if (!this.invalidStockProducts.includes(item.productCode)) {
                        this.invalidStockProducts.push(item.productCode);
                      }
                    }
                  }
                }
              });
          }
        }
      });
    }
  }

  calculateSum(item) {
    if (!this.taxesLoaded || !this.featuresLoaded) {
      return;
    }

    item.total = this.calc(item).total;
    item.total = this.round(item.total);
    item.net = this.calc(item).net;
    this.$scope.$emit('productSummary', this.calculateTotal(this.items));

    return item;
  }

  calculateFromSum(item) {
    if (!this.taxesLoaded || !this.featuresLoaded) {
      return;
    }
    let quantity = this.$filter('numberify')(item.quantity) || 0;
    let total = this.$filter('numberify')(item.total) || 0;
    //change possible comma to dot
    item.total = total;
    let discount = parseFloat(item.discount) || 0;
    let taxRate = parseFloat(item.taxRate) || 0;

    // let taxAmount = total / (1 + (taxRate / 100));
    let net = total / (1 + (taxRate / 100));

    if (discount > 0 || discount !== null) {
      let discountPrcnt = 100 - discount;
      net = net * 100 / discountPrcnt;
      // net = net * (100 - discount) / 100;
    }

    if (quantity > 0) {
      let unitPrice = net / quantity;
      item.net = this.round(net);
      item.unitPrice = this.round(unitPrice);
    }

    this.$scope.$emit('productSummary', this.calculateTotal(this.items));

    return item;
  }

  add() {
    this.items.push({
      number: this.items.length ? this.items[this.items.length - 1].number + 1 : 1,
      quantity: null,
      productCode: null,
      description: null,
      unitPrice: null,
      discount: this.discount || null,
      taxRate: this.mva ? 25 : 0,
      total: 0
    });
  }

  addArtTax() {
    if (this.artTaxAdded) {
      return;
    }
    this.artTaxAdded = true;
    let artTax = this.calcArtTax(this.items);
    this.items.push({
      number: this.items.length ? this.items[this.items.length - 1].number + 1 : 1,
      quantity: 1,
      productCode: null,
      description: this.artTaxText,
      unitPrice: artTax,
      discount: null,
      artTax: true,
      taxRate: this.mva ? 25 : 0,
      total: 0
    });
    this.calculateSum(this.items[this.items.length - 1]);
    // this.$scope.$emit('productSummary', this.calculateTotal(this.items));
  }

  remove(index) {
    let artTaxLine = this.items[index].artTax;
    if (artTaxLine) {
      this.artTaxAdded = false;
    }

    this.items.splice(index, 1);

    // reindex
    this.items.forEach((item, i) => {
      item.number = i + 1;
      return item;
    });

    this.$scope.$emit('productSummary', this.calculateTotal(this.items));
    this.$scope.$emit('productList', this.items);
  }

  lookup(i) {
    let item = this.items[i];

    if (item.productCode && item.productCode.length) {
      this.productService.search(item.productCode)
        .then((resp) => {
          if (resp.data.items.length) {
            let result = resp.data.items[0];

            if (result.stockManaged) {
              if (!(result.code in this.productStock)) {
                this.productStock[result.code] = result.quantity | 0;
              }
            }
            // check if the field was edited before the lookup and keep the original
            angular.extend(this.items[i], {
              description: result.description,
              unitPrice: result.unitPrice,
              taxRate: this.mva ? result.taxRate : 0
            });

            // this.validateStock(item);
            this.validateStockForAll();
            this.calculateSum(this.items[i]);
          }
        });
    }
  }

  search(i) {
    // set temp index and open panel
    this.index = i;
    this.panel = true;
  }

  select(i, item) {
    angular.extend(this.items[i], {
      productCode: item.code,
      description: item.description,
      unitPrice: item.unitPrice,
      taxRate: item.taxRate
    });

    this.calculateSum(this.items[i]);
    // this.validateStock(this.items[i]);
    this.validateStockForAll();

    // reset temp index and close panel
    this.index = null;
    this.panel = false;
  }
}

ProductPicker.$inject = ['$scope', '$filter', 'productService', 'commonService', 'userService', 'originatorService'];

const productPicker = {
  bindings: {
    maxItems: '<',
    discount: '<',
    items: '<',
    mva: '<',
    includeTax: '<',
    checkStock: '<',
    i18n: '<'
  },
  controller: ProductPicker,
  template: `
    <div ng-form name="invoiceLines">
      <alert data="$ctrl.alert" ng-show="invoiceLines.$invalid" />
      <div class="alert-box warn" ng-if="$ctrl.invalidStockProducts.length">
        <div ng-bind-html="$ctrl.prepareMessage() | html"></div>
      </div>

<!--      <alert data="$ctrl.alertStock" ng-show="$ctrl.invalidStockProducts.length > 0" />-->

      <table ng-show="$ctrl.items.length" id="invoiceLines">
        <thead>
          <tr>
            <th></th>
            <th>{{ $ctrl.i18n.QUANTITY }}</th>
          <th></th>
          <th>{{ $ctrl.i18n.CODE }}</th>
          <th>{{ $ctrl.i18n.DESCRIPTION }}</th>
          <th class="right-align">{{ $ctrl.i18n.UNITPRICE }}</th>
          <th class="right-align">{{ $ctrl.i18n.DISCOUNT }}</th>
          <th>{{ $ctrl.i18n.TAXRATE }}</th>
          <th class="right-align">{{ $ctrl.i18n.TOTAL }}</th>
          <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.items track by $index" data-index="{{ $index }}">
            <td style="width: 25px;">
              <i class="fa fa-sort" style="cursor: move;"></i>
            </td>
            <td style="width: 75px;">
<!--                <input type="text" name="items[{{ $index }}].quantity" ng-pattern="/^-?\\d+(?:[,.]\\d{1,2})?$/" ng-change="$ctrl.validateStock(item)" ng-model="item.quantity" maxlength="6" ng-blur="$ctrl.calculateSum(item)" ng-disabled="item.artTax">-->
                <input type="text" name="items[{{ $index }}].quantity" ng-pattern="/^-?\\d+(?:[,.]\\d{1,2})?$/" ng-change="$ctrl.validateStockForAll()" ng-model="item.quantity" maxlength="6" ng-blur="$ctrl.calculateSum(item)" ng-disabled="item.artTax">
            </td>
            <td style="width: 25px;">
              <i ng-hide="item.artTax" class="fa fa-search" ng-click="$ctrl.search($index)"></i>
            </td>
            <td style="width: 90px;">
              <input type="text" name="items[{{ $index }}].productCode" ng-model="item.productCode" maxlength="9" ng-blur="$ctrl.lookup($index)" ng-change="$ctrl.calculateSum(item)" ng-disabled="item.artTax">
            </td>
            <td style="width: 345px;">
              <input type="text" name="items[{{ $index }}].description" ng-model="item.description" maxlength="75" ng-disabled="item.artTax">
            </td>
            <td style="width: 90px;">
              <input type="text" name="items[{{ $index }}].unitPrice" ng-pattern="/^-?\\d+(?:[,.]\\d{1,2})?$/" ng-model="item.unitPrice" maxlength="9" ng-blur="$ctrl.calculateSum(item)" ng-disabled="item.artTax">
            </td>
            <td style="width: 75px;">
              <input type="number" name="items[{{ $index }}].discount" ng-model="item.discount" min="0" max="100" maxlength="5" ng-blur="$ctrl.calculateSum(item)" ng-disabled="item.artTax">
            </td>
            <td style="width: 75px;">
              <select ng-show="$ctrl.mva" class="select-box" name="items[{{ $index }}].taxRate" ng-model="item.taxRate" ng-options="value for value in $ctrl.taxRates" ng-blur="$ctrl.calculateSum(item)"></select>
              <span ng-hide="$ctrl.mva" data-balloon="For å fakturere med MVA må du velge at du er registrert i MVA-registeret på Konto-siden.">
                {{ item.taxRate }} <i ng-show="$index === 0" class="fa fa-question-circle"></i>
              </span>
            </td>
            <td class="right-align nowrap" style="width: 85px;" ng-if="$ctrl.includeTax">
              <input type="text" name="items[{{ $index }}].total" ng-pattern="/^-?\\d+(?:[,.]\\d{1,2})?$/" ng-model="item.total" maxlength="10" ng-blur="$ctrl.calculateFromSum(item)" ng-disabled="item.artTax">
            </td>
            <td ng-hide="$ctrl.includeTax" class="right-align nowrap" style="width: 75px;">{{ $ctrl.includeTax ? item.total : item.net | crowns:false }}</td>
            <td style="width: 25px;">
              <i ng-show="$ctrl.items.length > 1" class="fa fa-times" ng-click="$ctrl.remove($index)"></i>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="large-6 columns">
          <button ng-click="$ctrl.add()" ng-show="$ctrl.items.length < $ctrl.maxItems" class="button"><i class="fa fa-plus"></i> Ny linje</button>
          <button ng-click="$ctrl.addArtTax()" ng-show="$ctrl.artTaxEnabled && !$ctrl.artTaxAdded && $ctrl.items.length < $ctrl.maxItems - 1" class="button"><i class="fa fa-plus"></i> Legg til kunstavgift linje</button>
        </div>
        <div class="large-6 columns right-align">
          <b>{{ $ctrl.items.length }}</b> av <b>{{ $ctrl.maxItems }}</b>
        </div>
      </div>

      <modal visible="$ctrl.panel">
        <h3 class="subheader">Produkter ({{ filtered.length }} stk)</h3>

        <input type="text" ng-model="q" placeholder="S&oslash;k" autocomplete="off">

        <table class="hovered">
          <thead>
            <tr>
              <th>Produktnr</th>
              <th>Beskrivelse</th>
              <th class="right-align">Enhetpris</th>
              <th class="right-align">MVA</th>
<!--              <th class="right-align">Antall</th>-->
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="item in filtered = ($ctrl.products | orderBy:'code' | filter:{$:q}) track by $index" ng-click="$ctrl.select($ctrl.index, item)">
              <td>
                <b>{{ item.code }}</b>
              </td>
              <td>{{ item.description }}</td>
              <td class="nowrap right-align">{{ item.unitPrice | crowns }}</td>
              <td class="right-align">{{ item.taxRate }}%</td>
<!--              <td class="right-align">{{ item.quantity }}</td>-->
            </tr>
          </tbody>
        </table>
      </modal>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('productPicker', productPicker);
